var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#848484",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 11.25,
    stroke: "#3B3B3B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 11.48H16.008C16.12 11.48 16.2533 11.4853 16.408 11.496C16.5627 11.5013 16.712 11.5173 16.856 11.544C17.48 11.64 18.0027 11.856 18.424 12.192C18.8507 12.5227 19.1707 12.9387 19.384 13.44C19.5973 13.9413 19.704 14.4987 19.704 15.112C19.704 15.976 19.4933 16.72 19.072 17.344C18.656 17.9627 18.0347 18.384 17.208 18.608C17.0107 18.6613 16.8187 18.6987 16.632 18.72C16.4453 18.736 16.2293 18.744 15.984 18.744H13.12V17.392H15.96C16.0613 17.392 16.176 17.3867 16.304 17.376C16.4373 17.3653 16.5627 17.3467 16.68 17.32C17.048 17.2347 17.3467 17.08 17.576 16.856C17.8107 16.6267 17.9813 16.36 18.088 16.056C18.1947 15.7467 18.248 15.432 18.248 15.112C18.248 14.792 18.1947 14.4773 18.088 14.168C17.9813 13.8587 17.8107 13.592 17.576 13.368C17.3467 13.1387 17.048 12.984 16.68 12.904C16.5627 12.872 16.4373 12.8533 16.304 12.848C16.176 12.8373 16.0613 12.832 15.96 12.832H13.12V11.48ZM13.12 18.744L14.608 18.28L19.944 23H17.912L13.12 18.744ZM13.152 15.68V14.536H20.904V15.68H13.152ZM15.864 12.624V11.48H20.872V12.624H15.864Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1256f1fe2ac6f529e4ba7beff1959575.svg";
export { ForwardRef as ReactComponent };